export default "__VITE_ASSET__oCud9npc__"